export default __webpack_public_path__ + "static/media/syllabus.a6391b4f.jpg";